export * from './ckeditor-configuration';